import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ProgressBarContainer, Item  } from './styles';
import { CheckInIcon, IdentityIcon, CreditCardIcon, KeycardIcon } from 'assets/icons';

const ProgressBar = ({step, groupId, status}) => {

  const history = useHistory();

  useEffect(() => {
    if(status) {
      if (status === "CHECKED_IN") {
        history.push(`/group-check-in/print-key/${groupId}`);
      } else if (status !== "PENDING" ) {      
        history.push(`/booking-details/${groupId}`);
      }
    }
  }, [status]);

  return (
    <ProgressBarContainer>
      <Item
        highlight={step === 1}
        onClick ={() => history.push(`/group-check-in/early-check-in/${groupId}`)}
      >
        <CheckInIcon />
        Early Checkin
      </Item>
      <hr className="divider" />
      <Item
        highlight={step === 2}
        onClick ={() => history.push(`/group-check-in/confirm-identity/${groupId}`)}
      >
        <IdentityIcon />
        Identification 
      </Item>
      <hr className="divider" />
      <Item
        highlight={step === 3}
        onClick ={() => history.push(`/group-check-in/payment/${groupId}`)}
      >
        <CreditCardIcon />
        Payment
      </Item>
      <hr className="divider" />
      <Item
        highlight={step === 4}
        onClick ={() => history.push(`/group-check-in/print-key/${groupId}`)}
      >
        <KeycardIcon />
        Print Key
      </Item>
    </ProgressBarContainer>
  )
}

export default ProgressBar;